module.exports = {"530112001":"西苑街道","530112002":"马街街道","530112003":"金碧街道","530112004":"永昌街道","530112005":"前卫街道","530112006":"福海街道","530112007":"棕树营街道","530112008":"碧鸡街道","530112009":"海口街道","530112010":"团结街道","530112403":"昆明滇池国家旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530112.json
// module id = 2353
// module chunks = 0